import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=0efc0882&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=0efc0882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc0882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efc0882')) {
      api.createRecord('0efc0882', component.options)
    } else {
      api.reload('0efc0882', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=0efc0882&scoped=true&", function () {
      api.rerender('0efc0882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27x0aHFxeeg0L/JS/comp/CookieBox.vue"
export default component.exports